import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6c940b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "company_view" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "swiper" }
const _hoisted_5 = { class: "swiper_content" }

import { ref, onMounted, onUnmounted, onActivated } from 'vue'
import useSwiper from '@/utils/useSwiper'
import AboutUsView from './AboutUsView.vue'
import Mitt from "@/utils/mitt";
import routerHash from "@/constant/router_hash";

const MAX_INDEX = 2
const unit = 33.33


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

const swiperRef = ref<HTMLDivElement | null>(null)

const onSwiper = (index:number) => currentIndex.value = index
const { currentIndex } = useSwiper(unit, MAX_INDEX)

onMounted(() => {
  Mitt.on(routerHash.CONTACT_US, () => {
    swiperRef.value!.scrollIntoView(true)
  })
})

onUnmounted(() => {
  Mitt.off(routerHash.CONTACT_US)
})

onActivated(() => window.scrollTo({ top: 0 }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('company.COMPANY_DESCRIPTION')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "swiper_item",
          ref_key: "swiperRef",
          ref: swiperRef
        }, [
          _createVNode(AboutUsView)
        ], 512)
      ])
    ])
  ]))
}
}

})